import { AlocacaoFuncionario } from './alocacao-funcionario';
import { Cargo } from './cargo';
import { ConclusaoParecer } from './conclusao-parecer';
import { Departamento } from './departamento';
import { Dependentes } from './dependentes';
import { Empresa } from './empresa';
import { ParecerEntrevistador } from './parecer-entrevistador';
import { PessoaFisica } from './pessoa-fisica';
import { Unidade } from './unidade';

export class Funcionario {
    id: number;
	matricula: string;
	dataAdmissao: Date;
	dataDemissao: Date;
	tipoFuncionario: string;
	salarioPretendido: number;
	cargo: Cargo;
    pessoasFisica: PessoaFisica;
    unidade: Unidade;
	dtHrEntrevista: Date;
    parecerEntrevistador: ParecerEntrevistador;
	descricaoParecerEntrevistador: string;
	conclusaoParecer: ConclusaoParecer;
	funcionarioEntrevistador: Funcionario;
	empresaFuncionario: Empresa;
	horaEntrevista?: string;
	descontaValeTransporte: boolean;
	descontaPecunia: boolean;
	departamento: Departamento;
	alocacoesFuncionario: AlocacaoFuncionario[];
	dependentes: Dependentes[];
	horaInicioJornada: string;
	horaFimJornada: string;
	descMotivoDemissao: string;
	dataUltimoExame: Date;

}